import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { SITE_DOMAIN, SITE_NAME } from './constants/site';
import { CartProvider } from './context/CartContext';
import { RouteFallback } from './components/DeferredSection';
import { PRODUCTS } from './data/catalog';
import './App.css';

const HomePage = lazy(() => import('./pages/HomePage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const CartPage = lazy(() => import('./pages/CartPage'));
const ProductPage = lazy(() => import('./pages/ProductPage'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const RefundPolicy = lazy(() => import('./pages/RefundPolicy'));

const PAGE_TITLES = {
  '/': `${SITE_NAME} | genealogypacks.online`,
  '/contact': `Contact | ${SITE_DOMAIN}`,
  '/cart': `Cart | ${SITE_DOMAIN}`,
  '/privacy-policy': `Privacy Policy | ${SITE_DOMAIN}`,
  '/terms-of-service': `Terms of Service | ${SITE_DOMAIN}`,
  '/refund-policy': `Refund Policy | ${SITE_DOMAIN}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const productMatch = pathname.match(/^\/product\/([^/]+)/);
    if (productMatch) {
      const product = PRODUCTS.find((p) => p.id === productMatch[1]);
      document.title = product
        ? `${product.name} | ${SITE_DOMAIN}`
        : `Product | ${SITE_DOMAIN}`;
    } else {
      document.title = PAGE_TITLES[pathname] || PAGE_TITLES['/'];
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <div className="App">
          <DocumentTitle />
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/product/:productId" element={<ProductPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
            </Routes>
          </Suspense>
        </div>
      </CartProvider>
    </BrowserRouter>
  );
}
